/// <reference types="vite-plugin-svgr/client" />
import LoadingIconImage from '~/assets/images/loading-icon.svg?react';
import { Box, Modal, Typography } from '@mui/material';

export interface LoadingModalProps {
  open: boolean;
  title: string;
  description: string;
  subtitle?: string;
}

export default function LoadingModal({ open, title, description, subtitle }: LoadingModalProps) {
  return (
    <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box
        sx={{
          borderRadius: '10px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 600,
          bgcolor: 'rgb(246, 247, 251)',
        }}>
        <Box
          sx={{
            px: 8,
            py: 6,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            '@keyframes spin': {
              '0%': {
                transform: 'rotate(0deg)',
              },
              '100%': {
                transform: 'rotate(360deg)',
              },
            },
          }}>
          <Box sx={{ mb: 3 }}>
            <LoadingIconImage
              style={{
                animation: 'spin 1s linear infinite',
                width: '64px',
                height: '64px',
              }}
            />
          </Box>

          <Typography
            variant="h2"
            sx={{
              fontSize: '1.5em',
              fontWeight: 600,
              mb: 2,
              color: 'text.primary',
            }}>
            {title}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              mb: 1,
              color: 'text.secondary',
              fontSize: '1rem',
            }}>
            {description}
          </Typography>

          {subtitle && (
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                fontSize: '0.875rem',
              }}>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
    </Modal>
  );
}
